import { render } from "./PageSymabio.vue?vue&type=template&id=a1a76c64"
import script from "./PageSymabio.vue?vue&type=script&lang=js"
export * from "./PageSymabio.vue?vue&type=script&lang=js"

import "./PageSymabio.vue?vue&type=style&index=0&id=a1a76c64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__